var render, staticRenderFns
import script from "./FormWithTabs.js?vue&type=script&lang=js&"
export * from "./FormWithTabs.js?vue&type=script&lang=js&"
import style0 from "./FormWithTabs.vue?vue&type=style&index=0&id=03655b0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03655b0f",
  null
  
)

export default component.exports